/* eslint-disable max-len */
export const findProductIndex = (state) => (payload) => state.products.findIndex((product) => product.uid === payload.uid);
export const findDrinkProductIndex = (state) => (payload) => {
  const filtered = state.drinks.filter((type) => type.id === payload.id);
  return filtered[filtered.length - 1];
};
